import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@shared/ui/card";
import { Progress } from "@shared/ui/progress";
import { HardDrive } from "lucide-react";
import { FormattedMessage, useIntl } from "react-intl";

export function Quotas() {
	const intl = useIntl();

	const storage = [
		{
			label: intl.formatMessage({
				id: "dashboard.quotas.database",
				defaultMessage: "Database",
			}),
			used: 4.7,
			total: 8,
			unit: "GB",
		},
		{
			label: intl.formatMessage({
				id: "dashboard.quotas.storage",
				defaultMessage: "Storage",
			}),
			used: 18.2,
			total: 50,
			unit: "GB",
		},
		{
			label: intl.formatMessage({
				id: "dashboard.quotas.bandwidth",
				defaultMessage: "Bandwidth",
			}),
			used: 142,
			total: 250,
			unit: "GB",
		},
		{
			label: intl.formatMessage({
				id: "dashboard.quotas.edgeInvocations",
				defaultMessage: "Edge invocations",
			}),
			used: 384_000,
			total: 1_000_000,
			unit: "",
		},
	];

	return (
		<Card>
			<CardHeader>
				<CardTitle className="flex items-center gap-2">
					<HardDrive className="h-4 w-4 text-muted-foreground" />
					<FormattedMessage id="dashboard.quotas.title" defaultMessage="Quotas" />
				</CardTitle>
				<CardDescription>
					<FormattedMessage
						id="dashboard.quotas.description"
						defaultMessage="Usage of plan limits"
					/>
				</CardDescription>
			</CardHeader>
			<CardContent className="space-y-5">
				{storage.map((s) => {
					const pct = Math.round((s.used / s.total) * 100);
					const fmt = (n: number) =>
						n >= 1000 ? n.toLocaleString() : `${n}${s.unit ? ` ${s.unit}` : ""}`;
					return (
						<div key={s.label} className="space-y-2">
							<div className="flex items-center justify-between text-sm">
								<span className="text-muted-foreground">{s.label}</span>
								<span className="tabular-nums">
									{fmt(s.used)} / {fmt(s.total)}
								</span>
							</div>
							<Progress value={pct} />
						</div>
					);
				})}
			</CardContent>
		</Card>
	);
}
